import { RecProduct, RecProductProps } from '@pro-page-components/rec-product';
import { useChildrenVisibilityEditor } from '@pro-page-components/utils/useChildrenVisibility';
import { useRestrictComponentByRegion } from '@pro-page-components/utils/useRestrictComponentByRegion';
import * as React from 'react';
import { ComponentForEditor } from 'react-page-editor/state';

import config from './config.json';
import defaultProps from './defaultProps.json';

export const RecTwinPeak5Series: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  const restrict = useRestrictComponentByRegion(config);
  if (restrict) return null;
  return <RecProduct {...props} />;
};

export const RecTwinPeak5SeriesEditor: ComponentForEditor<RecProductProps> = (
  props: RecProductProps,
) => {
  // eslint-disable-next-line no-underscore-dangle,react/destructuring-assignment
  const visible = useChildrenVisibilityEditor(props.__config);
  if (!visible) return null;
  return <RecTwinPeak5Series scale={0.9} skipVisibilityCheck {...props} />;
};

RecTwinPeak5Series.defaultProps = defaultProps as RecProductProps;
RecTwinPeak5Series.config = config;
RecTwinPeak5SeriesEditor.defaultProps = defaultProps as RecProductProps;
RecTwinPeak5SeriesEditor.config = config;
